import React from "react";

import GridBomModal from "fond/project/bom/GridBomModal";
import { BomModalProps } from "fond/project/bom/index";

const BomModal: React.FC<BomModalProps> = ({ title = "Materials and Costs", project, architecture, onClose }: BomModalProps) => {
  return <GridBomModal project={project} architecture={architecture} onClose={onClose} title={title} />;
};

export default BomModal;
